import { useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import InvoiceCreateForm from '../components/Invoice/InvoiceCreateForm';

export default function InvoiceCreatePage() {
  const { id: invoiceId } = useParams();
  const [searchParams] = useSearchParams();
  const invoiceFormRef = useRef();

  // ?type=dispatch opens the form on Испратница — that is how the Испратници
  // list's "Нова Испратница" button gets here. Anything else means Фактура.
  const initialDocumentType = searchParams.get('type') === 'dispatch' ? 'dispatch' : 'invoice';

  return (
    <InvoiceCreateForm
      ref={invoiceFormRef}
      isEdit={!!invoiceId}
      initialDocumentType={initialDocumentType}
    />
  );
}
